import React from 'react'

export type ProductSchemaProps = {
  itemRef?: string
  id: string
  title: string
  description?: string
  images: string[]
  rating?: {
    score: number
    count?: number
  } | null
  offers: {
    sku: string
    price: string
    currencyCode: string
    inStock: boolean
  }[]
}

export const ProductSchema: React.FC<ProductSchemaProps> = ({
  offers,
  title,
  description,
  id,
  images,
  rating,
  itemRef,
}) => {
  return (
    <div
      itemScope
      itemType="https://schema.org/Product"
      itemRef={itemRef}
      data-testid="mp-shared-product-schema"
    >
      <meta content={id} itemProp="sku" />
      <meta itemProp="name" content={title} />
      {description && (
        <div
          itemProp="description"
          style={{ display: 'none' }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {rating && (
        <div
          itemProp="aggregateRating"
          itemScope
          itemType="https://schema.org/AggregateRating"
        >
          <meta itemProp="ratingValue" content={String(rating.score)} />
          {rating.count && (
            <meta itemProp="reviewCount" content={String(rating.count)} />
          )}
        </div>
      )}

      {images.map(image => (
        <meta key={image} itemProp="image" content={image} />
      ))}

      {offers.map(({ price, sku, currencyCode, inStock }) => {
        const priceForCrawler = price.replace(',', '.')

        return (
          <div
            key={sku}
            itemProp="offers"
            itemScope
            itemType="http://schema.org/Offer"
          >
            <meta
              itemProp="price"
              content={priceForCrawler}
              data-testid="item-prop-price"
            />
            <meta content={currencyCode} itemProp="priceCurrency" />
            <meta content={sku} itemProp="sku" />
            <meta
              itemProp="availability"
              content={
                inStock
                  ? 'https://schema.org/InStock'
                  : 'https://schema.org/OutOfStock'
              }
            />
          </div>
        )
      })}
    </div>
  )
}
